module.exports = __webpack_public_path__ + "static/assets/f0da248e34f4b4519374fd5185e39129.svg";